import { useIntl } from 'react-intl'
import { useFormContext } from 'react-hook-form'

import { NaturalFormPresentational } from '../../../../../../../../components/Forms/NaturalFormPresentational'
import { type NaturalStepFormValues } from './types/FormsSteps'

type NaturalStepFormProps = {
  isSubmitting: boolean
  onCancel: () => void
  onSubmit: () => void
}

export const NaturalStepForm = ({
  isSubmitting,
  onCancel,
  onSubmit,
}: NaturalStepFormProps) => {
  const methods = useFormContext<NaturalStepFormValues>()
  const { formatMessage } = useIntl()

  return (
    <NaturalFormPresentational
      isSubmitting={isSubmitting}
      submitButtonText={formatMessage({ id: 'CONTINUE' })}
      onSubmit={onSubmit}
      onCancel={onCancel}
      {...methods}
    />
  )
}
